// @flow
'use strict';

import * as _ from 'lodash';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, reset } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';

import * as classificacao from '../../../../reducers/nfe/classificacao_fiscal';
import * as modal from '../../../../reducers//modal';
import { ajaxError, alert } from 'reducers/alerts';
import { requestData } from '../../../../reducers/documento';
import { formToQuery } from 'lib/viewUtils';
import request from 'lib/request';

import ModalClassificacaoFiscal from './modal_classificacao_fiscal';

export default compose(
    connect<*, *, *, *, *, *>(createStructuredSelector({
          open: modal.openModalSelector,
          listaOpcoes: classificacao.listaClassificacaoSelector,
          initialValues: classificacao.rootSelector,
        }),
        { ...classificacao, ...modal }),
    reduxForm({
      form: 'classificacaoFiscal', enableReinitialize: true,
      onSubmit(form, dispatch) {
        if (!form.get("opcaoClassificacao"))
          return dispatch(alert('danger', "O campo Classificação geral deve ser preenchido."));

        request.patch(form.get('url'))
            .accept('json')
            .query(formToQuery(_.omit(form.toJS(), 'url')))
            .then((r) => {
              if (r.body.alertas && r.body.alertas.length > 0)
                window.alert(r.body.alertas.join('\n\n'));
              else {
                dispatch(alert('info', 'Classificação salva.'));
                dispatch(reset('classificacaoFiscal'));
                dispatch(modal.fechaModal());
                dispatch(requestData());
              }
            })
            .catch(e => dispatch(ajaxError('Erro desconhecido ao salvar classificação. Entre em contato com o suporte.', e)));
      },
    }),
)(ModalClassificacaoFiscal);
